import Vue from "vue"
import VueI18n from "vue-i18n"
import store from "@/store/"
import getLocale from "@/utils/locale"
import CategoryExplorer from "@/component-library/category-explorer"

const init = (container) => {
  const { categories: categoriesJson, defaultCategorySlug, backgroundColor, ctaClass, ctaCopy } = container.dataset

  const categories = JSON.parse(categoriesJson)

  Vue.use(VueI18n)

  new Vue({
    name: "CategoryExplorer",
    el: container,
    store,
    i18n: new VueI18n({ locale: getLocale() }),
    render: (h) =>
      h(CategoryExplorer, {
        props: {
          categories,
          defaultCategorySlug,
          backgroundColor,
          ctaClass,
          ctaCopy
        }
      })
  })
}

export const eventHandlers = {
  "abtest:toggled": () => {
    document.querySelectorAll(".js-category-explorer").forEach((el) => {
      init(el)
    })
  }
}
